export function isMobilePlatform(): boolean {
	if (typeof navigator === 'undefined') {
		return false
	}

	const ua = navigator.userAgent

	if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
		return true
	}

	// iPadOS 13+ reports as MacIntel with touch
	if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
		return true
	}

	return /iPad/i.test(ua)
}
